export default __webpack_public_path__ + "media/img_01/1000-18b8bbd7.jpg";